import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconManager } from '@speeki/icons';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { useServiceRedirect } from '@utils/hooks/useServiceRedirect';
import { useUserLogin } from '@utils/hooks/useUserLogin';

import { getPath } from '@services/RouteService/paths';

import { FormBottomElement } from '@domains/auth/molecules/FormBottomElement/FormBottomElement';
import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';
import { LoginForm } from '@domains/auth/organisms/LoginForm/LoginForm';

export const StartNewReportLoginPage = () => {
    useServiceRedirect({ path: '/new-conversation' });
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { login, sessionProcessing } = useUserLogin();

    return (
        <ColumnsLayout
            breadcrumb={t('START_NEW_REPORT_TITLE')}
            contentPadding={{
                bottom: 40,
                top: 16,
            }}
            title={t('START_NEW_REPORT_TITLE')}
        >
            <Card testId="qIFm6c3">
                <Card.TitleTertiary>
                    {t('ALREADY_HAVE_AN_ACCOUNT')}
                </Card.TitleTertiary>
                <Card.Description>
                    {t('NEW_LOGIN_DESCRIPTION')}
                </Card.Description>
                <LoginForm
                    bottomElement={
                        <FormBottomElement
                            buttonText={t('CONTINUE_AS_A_GUEST')}
                            onSubmit={() =>
                                navigate(
                                    getPath({ path: '/auth/start-new-report' }),
                                )
                            }
                        />
                    }
                    handleLoginSubmit={login}
                    loading={sessionProcessing}
                />
            </Card>
            <LoginBanner>
                <IconManager icon={'SvgInfo'} size={16} />
                <LoginBanner.Description>
                    {t('NEW_TO_SPEEKI')}{' '}
                    <LoginBanner.Link to={getPath({ path: '/auth/signup' })}>
                        {t('CREATE_SPEEKI_ACCOUNT')}!
                    </LoginBanner.Link>
                </LoginBanner.Description>
            </LoginBanner>
        </ColumnsLayout>
    );
};
